export const describeStrings = {
  common: {
    continue: 'Continue',
  },
  pageHeader: {
    title: 'Project Apollo Retrospective',
    stageDescribe: 'Describe',
    stageGatherFacts: 'Gather Facts',
    stageMatchPoints: 'Match points',
    stageDeepDive: 'Deep-dive',
    stageLessons: 'Lessons',
    stageSubtitles: {
      describe: 'Stage 1 of 5 - Describe the situation',
      gather: 'Stage 2 of 5 - Gather the facts',
      'match-points': 'Stage 3 of 5 - Pick match-points',
      'deep-dive': 'Stage 4 of 5 - Deep-dive',
      lessons: 'Stage 5 of 5 - Lessons',
    },
  },
  intro: {
    title: "Let's unpack what happened.",
    subtitle:
      "We'll review the goal, what actually occurred, and trace the history to define better paths forward.",
  },
  goal: {
    heading: 'What were we trying to achieve?',
    subheading: 'Describe the goal in your own words. We may suggest a ticket.',
    placeholder: 'Describe the goal...',
    submitHint: 'Press Cmd/Ctrl+Enter to continue',
    matchHeading: 'Possible match',
    matchAccept: 'Attach',
    matchDismiss: 'Dismiss',
    completedLabel: 'Goal',
  },
  outcome: {
    heading: 'Did we hit the intended outcome?',
    subheading:
      'Tell us whether the goal was achieved, and add context if you want.',
    achieved: 'Achieved',
    notAchieved: 'Not Achieved',
    contextLabel: 'More context',
    contextPlaceholder: 'What else should we know?',
    completedLabel: 'Outcome',
  },
  date: {
    heading: 'When did this happen?',
    subheading: 'Pick the start and end dates of this work.',
    placeholder: 'Pick a date range',
    completedLabel: 'Date',
  },
  people: {
    heading: 'Who else was involved?',
    subheading:
      'Tag key decision makers and execution leads so we can pull their context.',
    searchPlaceholder: 'Type a name...',
    submitHint: 'Press Cmd/Ctrl+Enter to continue',
    completedLabel: 'People',
    empty: 'Nobody selected yet.',
  },
  followUps: {
    label: 'FOLLOW-UP',
    submitHint: 'Press Cmd/Ctrl+Enter to continue',
    placeholder: 'Your thoughts...',
  },
  situationCaptured: {
    heading: 'Situation captured',
    body: "I have enough context. I'll pull tickets, Slack threads, and recent PRs to reconstruct the timeline.",
    continue: 'Continue to gathered Facts',
    continueDisabledTooltip: 'Coming soon',
    factsError: "Couldn't gather facts. Please try again.",
    goalCount: (count: number) => `${count} Goal${count === 1 ? '' : 's'}`,
    peopleCount: (count: number) => `${count} Person${count === 1 ? '' : 's'}`,
    outcomeAchieved: 'Achieved',
    outcomeMissed: 'Missed',
  },
  nav: {
    debriefV2: 'New Debrief (Beta)',
    saveDraft: 'Save draft',
  },
} as const;

// Follow-up questions are deferred until the AI-driven follow-up flow is
// designed. Re-enable by uncommenting the entries below — the reducer,
// `FollowUpQuestion` mapping in `DescribePage.tsx`, and `SUBMIT_FOLLOWUP`
// action are already wired and will pick them up automatically.
export const FOLLOW_UP_QUESTIONS: ReadonlyArray<string> = [
  // 'What surprised you most about how this played out?',
  // "Looking back, what's the single biggest thing you'd do differently?",
];
